import googlePreferredIcon from "@assets/icons/googlePreferredSource.png";
import { GOOGLE_PREFERED_SOURCES_LINK } from "@config/OtherConstants";
import LinkIcon from "@elements/Icon/LinkIcon";
import { WEB2_BASE_URL } from "@helper/getEnvVariables";
import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { useTMCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useTMCustomEventAnalyticsCall";

export type googlePreferedButtonProps = {
  className?: string;
  pageUrl: string;
  isArticleFirstFoldEnabled?: boolean;
};
/**
 * A React component that renders a Google Preferred Source Button on Article page
 */
export default function GooglePreferedSourceButton({
  className,
  pageUrl,
  isArticleFirstFoldEnabled = false,
}: googlePreferedButtonProps): React.ReactElement {
  const TablaCustomGaEvent = useTMCustomEventAnalyticsCall();

  const handleOnClick = () => {
    TablaCustomGaEvent({
      event: "customEvent",
      eventCategory: "preferred source on google",
      eventAction: "click",
      eventLabel: `${removeTrailingSlash(WEB2_BASE_URL)}${pageUrl}`,
    });
  };

  return (
    <div className={className}>
      <LinkIcon
        destination={GOOGLE_PREFERED_SOURCES_LINK}
        onClick={() => {
          handleOnClick();
        }}
        src={googlePreferredIcon}
        alt="Google News Preferred Icon"
        height={isArticleFirstFoldEnabled ? "40px" : "39px"}
        width={isArticleFirstFoldEnabled ? "127px" : "125px"}
      />
    </div>
  );
}
